import { Component, inject, OnInit, ViewChild } from '@angular/core';
// import { IgxGridRowComponent } from '@infragistics/igniteui-angular/lib/grids/grid/grid-row.component';
// import { IgxGridCellComponent } from '@infragistics/igniteui-angular/lib/grids/cell.component';
import { ParkerStateService } from 'src/app/core/services/state/parker-state.service';
import { CommonModule, JsonPipe } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FormsModule } from '@angular/forms';

import { IgxGridComponent, IgxGridModule, IgxTabsModule } from '@infragistics/igniteui-angular';

@Component({
  selector: 'app-parkers-v2-grid-view-mass-update',
  templateUrl: './parkers-v2-grid-view-mass-update.component.html',
  styleUrl: './parkers-v2-grid-view-mass-update.component.scss',
  standalone: true,
  imports: [CommonModule, JsonPipe, MatSnackBarModule, IgxGridModule, FormsModule, IgxTabsModule],
  providers: [],
})
export class ParkersV2GridViewMassUpdate implements OnInit {
  @ViewChild('gridProfileMassUpdatezzz', { read: IgxGridComponent, static: false })
  public gridProfileMassUpdatezzz: IgxGridComponent;

  public options = {
    enabled: true,
    copyHeaders: true,
    copyFormatters: true,
    separator: '\t',
  };

  //Services
  parkerStateService = inject(ParkerStateService);

  constructor() {}

  ngOnInit(): void {}
}
